// extracted by mini-css-extract-plugin
export default {"label":"_9NxYK","mgT16":"_3KqaA","link":"_3Tos0","multiSelectOptions":"_1un4s"};